import React, { useCallback, useState } from 'react';
import * as DocumentApi from '../../../api/document';
import { DownloadURI } from '../../../lib/utils';
import Localization from '../../../config/localization';
import { Form, FormGroup, Label, Modal, ModalBody } from 'reactstrap';
import DatePicker from '../../../components/DatePicker';
import CountySearch from '../../../components/SearchInput/CountySearch';

export function PaymentArchive(props: { isAdmin: boolean }) {
  const { isAdmin } = props;

  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState({ month: '', countyCode: '' });

  const toggleIsOpen = useCallback(() => setIsOpen(value => !value), [setIsOpen]);

  const doDownload = useCallback(async (event: React.SyntheticEvent<HTMLFormElement>) => {
    if (event) event.preventDefault();

    const response = await DocumentApi.GetArchive(data);

    await DownloadURI(response.data.url);

    setIsOpen(false);
    setData({ month: '', countyCode: '' });
  }, [data, setData, setIsOpen]);

  return <>
    {isAdmin && <button className="eon-button bg-eon-red eon-white" onClick={toggleIsOpen}>
      <span className="px-3">{Localization.paymentsReportsArchiveButton}</span>
    </button>}

    <Modal centered isOpen={isOpen} toggle={toggleIsOpen}>
      <ModalBody className="px-4 pt-4">
        <h4 className="eon-title eon-darkgrey">{Localization.paymentsReportsArchiveModalTitle}</h4>
        <h6 className="eon-title eon-middle-grey  mt-2">{Localization.paymentsReportsArchiveModalDescription}</h6>

        <Form onSubmit={doDownload} className="my-4">
          <FormGroup className="my-2 w-100 d-inline-block ">
            <Label className="text-nowrap" for="month">
              {Localization.paymentsReportsArchiveModalMonthLabel}
            </Label>
            <fieldset className="eon-select large eon-red">
              <DatePicker
                name="month"
                id="month"
                value={data.month}
                onChange={(event) => setData(val => ({ ...val, month: event.currentTarget.value }))}
                className="eon-input-text"
              />
            </fieldset>
          </FormGroup>
          <CountySearch
            required
            width="w-100"
            margin="my-2"
            className=""
            onChange={(place: Utils.ICounty) => setData(val => ({
              ...val,
              countyCode: place ? place.countyCode : ''
            }))} />
          <div className="d-flex mt-4 pt-2">
            <button className="eon-button bg-eon-red eon-white mr-5">
              <span className="px-3">{Localization.paymentsReportsArchiveModalButtonSubmit}</span>
            </button>
            <button type="button" className="eon-button bg-eon-lightgrey eon-middle-grey mx-4" onClick={toggleIsOpen}>
              <span className="px-3">{Localization.paymentsReportsArchiveModalButtonCancel}</span>
            </button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  </>;
}
